import $ from 'jquery';
import { hideLoading, showLoading, numberWithCommas } from './utils';
import Watchlist from './watchlist';
import Car from './car';
import Bid from './bid';
import Start from './start';

var Modal = {
  element : null,
  content : null,
  id      : null,
  request : null,

  init: function() {
    this.element = $('#details');
    this.content = this.element.find('#details-content');

    window.onpopstate = this.onPopState;

    this.bind();
  },

  bind: function() {
    $('.show-details')
      .off('click')
      .on('click', this.showCarDetails);
  },

  show: function() {
    this.element.modal('show');
  },

  hide: function() {
    this.element.modal('hide');
  },

  replaceContent: function(content) {
    Modal.content.html(content);
    Modal.show();

    hideLoading();

    // Bind the different elements in the modal
    Modal.bindCarDetails();
    Modal.bindButtons();
    Modal.bindLightbox();
    Modal.bindExamples();
    Watchlist.bind();
  },

  showCarDetails: function(e) {
    e.preventDefault();

    var self = $(this);
    var requestUrl = self.attr('href');

    Modal.id = requestUrl.split('=')[1];

    var baseUrl = window.location.href.split('#')[0];
    var newUrl = baseUrl + '#' + Modal.id;
    var title = $(document).attr('title');

    window.history.pushState({id: Modal.id}, title, newUrl);
    Car.updateStatus({ id: Modal.id, status: 'viewed' });

    if(Modal.request !== null) {
      Modal.request.abort();
    }

    showLoading();
    Modal.request = $.get(requestUrl, Modal.replaceContent);
  },

  bindCarDetails: function() {
    var examples = $('#detail-price-examples');
    var average = $('#detail-price-average');

    examples.hide();

    if(Modal.request !== null) {
      Modal.request.abort();
    }

    Modal.request = $.post("/price-history/get.json", {id: Modal.id}, function (data) {
      examples.prepend(data.price.count).show();
      average.prepend( numberWithCommas(data.price.average * 1000) );
    });
  },

  bindButtons: function() {
    $('#show-bid')
      .off('click')
      .on('click', Bid.init);

    if(!Start.pageList) return;

    var prev = $('.btn.previous');
    var next = $('.btn.next');
    var baseUrl = prev.attr('href');

    for(var i = 0; i < Start.pageList.length; i++) {
      if('#' + Start.pageList[i] === window.location.hash) {
        if(i !== 0) {
          prev.css('display', 'inline-block');
          prev.attr('href', baseUrl + Start.pageList[i - 1]);
          prev.on('click', this.showCarDetails);
        }
        if(i !== (Start.pageList.length - 1)) {
          next.css('display', 'inline-block');
          next.attr('href', baseUrl + Start.pageList[i + 1]);
          next.on('click', this.showCarDetails);
        }
      }
    }
  },

  bindLightbox: function() {
    $('.lightbox-image').magnificPopup({
      type: 'image',
      gallery: {
        enabled: true
      },
      callbacks: {
        buildControls: function() { this.contentContainer.append(this.arrowLeft.add(this.arrowRight)); }, // re-appends controls inside the main container
        beforeOpen: function() { Modal.hide(); }, // Hide modal while the lightbox is opened
        beforeClose: function() { Modal.show(); } // then put it back when the lightbox is closed
      }
    });
  },

  bindExamples: function() {
    $('#detail-price-examples').on('click', function(e) {
      e.preventDefault();

      var detailsContent = Modal.content.html();

      $.get($(this).attr('href'), function(content) {
        Modal.content.html(content);

        $('#back-to-details').on('click', Modal.showCarDetails);
      });
    });
  },

  onPopState: function(e) {
    Main.showLoading();
    $.get('/cardetail/?id=' + e.state.id, Modal.replaceContent);
  }
};

export default Modal;



// WEBPACK FOOTER //
// ./app/webroot/javascript/modules/modal.js